<template>
  <v-row align="center" justify="center">
    <v-card>
      <v-card-title>
        Certificates
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="certificates" :search="search">
        <template v-slot:item.ID="{ item }">
          <span>{{ item.ID }}</span>
          &nbsp;
          <a
            link
            :href="'https://reports.deltadiamondlab.com/' + item.ID"
            target="_blank"
          >
            <v-hover v-slot:default="{ hover }">
              <v-icon :color="hover ? 'red' : 'grey'">mdi-file-pdf-box</v-icon>
            </v-hover>
          </a>
        </template>
        <!-- <template v-slot:item.generationDate="{ item }">
          <span>{{new Date(item.generationDate).toLocaleString()}}</span>
        </template>-->
      </v-data-table>
    </v-card>
  </v-row>
</template>

<script>
import session from "../api/session";
export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "ID", value: "ID" },
        { text: "Date", value: "generationDate" },
        { text: "Analyst", value: "user" },
        { text: "Customer", value: "customer" },
        { text: "Weight", value: "weight" },
        { text: "Colour", value: "colour" },
        { text: "Shape", value: "shape" },
        { text: "Width", value: "width" },
        { text: "Depth", value: "depth" }
      ],
      certificates: []
    };
  },
  created() {
    session.get("/api/cert/view/").then(request => {
      this.certificates = request.data;
    });
  }
};
</script>
